import { defineComponent as _defineComponent } from 'vue'
import { onMounted, ref } from "vue";


const __default__ = {
  name: "ToastMessage",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  message: {
    type: String,
    default: "",
  },
  durationMillis: {
    type: Number,
    default: 2500,
  },
  delayMillis: {
    type: Number,
    default: 300,
  },
},
  setup(__props, { expose: __expose }) {
  __expose();

const props = __props;

const show = ref(false);
onMounted(() => {
  setTimeout(() => {
    show.value = true;
  }, props.delayMillis);

  setTimeout(() => {
    show.value = false;
  }, props.durationMillis);
});

const __returned__ = { props, show }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})